import React from 'react'
import { Link } from 'react-router-dom'
import ApiUrl from '../../../../configTools/apiUrl'
import { ReactComponent as SoldIcon} from '../../../../images/icons/sold.svg'


const ProductItemCollection = ({Product}) => {
  return (
    <Link to={'/product/'+Product.slug}>
        <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+Product.image})`}}>
            <div className='public_home_product_grid_1_products_item_overlay'>
                <div className='public_home_product_grid_1_products_item_overlay_price'>
                    <p>
                        {Product.sold === 0 &&
                            <p>
                            {Product.compareatprice !== 0 && Product.compareatprice > Product.price && Product.compareatprice !== undefined &&
                                <b>Rs.{Product.compareatprice}/-</b>
                            }
                            Rs.{Product.price}/-
                            </p>
                        }
                        {Product.sold !== 0 &&
                            <p>
                            Sold
                            </p>
                        }
                    </p>
                </div>
            </div>
            {Product.sold !== 0 &&
                <div className='listing_activepin_overlay' style={{
                    justifyContent:"flex-start"
                }}>
                    <div className='listing_active_pin_icon'>
                        <SoldIcon width={'40px'} height={'40px'} />
                    </div>
                </div>
            }
        </div>
    </Link>
  )
}

export default ProductItemCollection
